
import { Component, Emit, InjectReactive, ProvideReactive, Vue } from 'vue-property-decorator'
import { Action, Getter } from 'vuex-class';

import BackSvg from '@/components/BackSvg.vue';
import MyLocation from '@/components/MyLocation.vue';
import OrderHistory from '@/components/OrderHistory.vue';
import SetLocation from '@/components/SetLocation.vue';
import SingleFavorite from '@/components/SingleFavorite.vue';
import SingleOrder from '@/components/SingleOrder.vue';
import { OrderMethods, Views } from '@/enums';
import UserModule from '@/store/modules/user';

@Component({
  components: {
    BackSvg,
    MyLocation,
    OrderHistory,
    SetLocation,
    SingleFavorite,
    SingleOrder,
  },
  metaInfo: {
    title: 'Cousins Subs',
    titleTemplate: '%s - Order - Select Location'
  }
})
export default class SelectLocation extends Vue {
  @Action fetchRestaurants: () => void;
  @Action fetchRestaurantsNearby: (coords: Coords) => void;
  @Getter activeRestaurant!: Restaurant;
  @Getter allRestaurants!: Restaurant[];
  @ProvideReactive('viewContainerRef') viewContainerRef: Element | undefined;
  @InjectReactive() isMobile!: boolean;

  OrderMethods = OrderMethods;
  previewOrderHistory: OrderModel | null;
  previewFavoriteOrder: FavoriteOrderModel | null;
  handleViewMoreFavoriteOrdersClicked: boolean;
  handleViewMoreRecentOrdersClicked: boolean;
  hideQuickOrders: boolean;
  favoriteOrderLimit: number | null;
  recentOrderLimit: number | null;

  data() {
    return {
      previewOrderHistory: null,
      previewFavoriteOrder: null,
      handleViewMoreFavoriteOrdersClicked: false,
      handleViewMoreRecentOrdersClicked: false,
      hideQuickOrders: false,
      favoriteOrderLimit: 2,
      recentOrderLimit: 2,
    }
  }

  get shouldLoadAll() {
    if (
      (this.allRestaurants && this.allRestaurants.length > 0) ||
      (UserModule.favoriteRestaurants && UserModule.favoriteRestaurants.length > 0)
    ) {
      return false;
    }
    return true;
  }

  async mounted() {
    this.viewContainerRef = this.$refs.container as Element;
    this.$scrollTo(this.viewContainerRef as Element);

    if (this.shouldLoadAll && !this.isMobile) {
      const loader = this.$loading.show();
      try {
        await this.fetchRestaurants();
      } catch (ex) {
      } finally {
        loader.hide();
      }
    }
  }

  get isLoggedIn() {
    return UserModule.loggedIn;
  }

  get orderHistory() {
    if (!UserModule.orderHistory || UserModule.orderHistory.length === 0) {
      return null;
    }
    return this.recentOrderLimit == null ? UserModule.orderHistory : UserModule.orderHistory.slice(0, this.recentOrderLimit);
  }

  get favoriteOrders() {
    if (!UserModule.favoriteOrders || UserModule.favoriteOrders.length === 0) {
      return null;
    }
    return this.favoriteOrderLimit == null ? UserModule.favoriteOrders : UserModule.favoriteOrders.slice(0, this.favoriteOrderLimit);
  }

  handleViewMoreRecentOrders() {
    this.handleViewMoreRecentOrdersClicked = true;
    this.recentOrderLimit = null;
  }

  handleViewMoreFavoriteOrders() {
    this.handleViewMoreFavoriteOrdersClicked = true;
    this.favoriteOrderLimit = null;
  }

  handleShowQuickOrders() {
    this.hideQuickOrders = false;
  }

  handleHideQuickOrders() {
    this.hideQuickOrders = true;
  }

  handleReOrder(restaurant) {
    this.handleHideQuickOrders();
    if (restaurant) {
      this.$router.push({
        name: Views.ORDER_SUMMARY,
        params: {
          location: restaurant.slug,
        }
      });
    }
  }

  get mapRef() {
    return (this.$refs.my_map || {} as any);
  }

  fitMapToBounds() {
    this.mapRef.fitBounds();
  }

  @Emit('show-login')
  handleLoginClick(ev) {
    return ev;
  }

  handlePreviewOrder(order) {
    this.previewOrderHistory = order;
  }

  handlePreviewFavorite(order) {
    this.previewFavoriteOrder = order;
  }
}
